import { HTMLAttributes } from 'react';
import { useJoveBreakpoint } from '@jove-frontend/uikit';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

type BrokerAreasOfExpertiseViewProps = HTMLAttributes<HTMLDivElement> & {
  info: {
    areasOfExpertiseTitle: string;
    areasOfExpertiseInfoList: string[];
  };
};

const BrokerAreasOfExpertiseView = (props: BrokerAreasOfExpertiseViewProps) => {
  const { className, info } = props;
  const { isMobileLayout } = useJoveBreakpoint();

  return (
    <Box className={clsx('flex flex-col items-center', className)}>
      <Box
        className={clsx(
          'flex flex-col items-center',
          isMobileLayout ? 'w-full space-y-2' : 'w-[960px] space-y-12'
        )}
      >
        <Box className="flex flex-row rounded-full bg-[#EBEFFE] px-3 py-2">
          <Typography
            variant="subtitle1"
            className="text-brand-secondary font-extrabold"
          >
            {info?.areasOfExpertiseTitle}
          </Typography>
        </Box>
        <Box className="flex flex-row flex-wrap gap-4">
          {(info?.areasOfExpertiseInfoList || []).map((item, index) => {
            return (
              <Box
                key={index}
                className={clsx(
                  'flex flex-row items-center space-x-1 rounded-2xl',
                  isMobileLayout ? 'px-3 py-2' : 'px-6 py-3'
                )}
                style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
              >
                <Typography
                  variant="subtitle1"
                  className={clsx(
                    'font-bold text-[#0E35D1]',
                    isMobileLayout ? '' : 'text-lg'
                  )}
                >
                  {item}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default BrokerAreasOfExpertiseView;
